import Vue from 'vue'
import protal from "@/api/protal";
let timer = null

Vue.mixin({
	data() {
		return {
			isPc: true,
			flag: true
		}
	},
    computed: {
        randomtag() {
            return '?t=' + new Date().getTime()
        },
        En() {
            return this.i18n.locale === 'en' ? 'En' : ''
        },
        baseSrc() {
            return this.$store.state.baseSrc
        },
		scrollTop() {
			return this.innerWidth < 1320 ?  this.$store.state.scrollTop * 1320 / this.innerWidth : this.$store.state.scrollTop
		},
		clientHeight() {
			return this.$store.state.clientHeight
		},
		innerWidth() {
			return this.$store.state.innerWidth
		},
		forumTypes() {
			return this.$store.state.forumTypes
		},
		pageLayout() {
			return this.isPc ? 'prev, pager, next, jumper' : 'prev, pager, next'
		},
		searchListBoolean() {
			return this.$store.state.searchListBoolean
		},
		successNum() {
			return this.$store.state.successNum
		},
		banners() {
			return this.$store.state.banners
		},
		openAd() {
			return this.$store.state.openAd
		},
		labels() {
			return this.$store.state.labels
		},
		pageTime() {
			return this.$store.state.pageTime
		},
    },
	created() {
		this.isPc = document.body.offsetWidth > 768
	},
    methods: {
		getForumType(uuid) { // 传入uuid返回论坛类型
			let str = ''
			this.forumTypes.forEach(x => {
				if (x.uuid === uuid) {
					str = x['lableDesc' + this.En]
				}
			})
			return str
		},
		turnNum(str) {
			if (str.includes('undefined') || str.includes('null')) return ''
			const s = str.replace(/./g, n => {
				if (/\d/.test(n)) {
					const img = `https://static.worldaic.com.cn/2024/web/static/images/n${n}.png`
					return `<img src="${img}" class="num-tupian" />`
				}
				if (n === '-') {
					const img = `https://static.worldaic.com.cn/2024/web/static/images/hengxian.png`
					return `<img src="${img}" class="num-tupian" />`
				}
				if ([':', '：'].includes(n)) {
					const img = `https://static.worldaic.com.cn/2024/web/static/images/maohao.png`
					return `<img src="${img}" class="num-tupian" />`
				}
			})
			return s
		},
		bannerClick(url) {
			window.open(url, "_blank");
		},
        setTime(time) {
			const date = time ? new Date(time) : new Date()
			const opt = {
				"y": date.getFullYear(), // 年
				"M": this.dubble(date.getMonth() + 1), // 月
				"d": this.dubble(date.getDate()), // 日
				"h": this.dubble(date.getHours()), // 时
				"m": this.dubble(date.getMinutes()), // 分
				"s": this.dubble(date.getSeconds()) // 秒
			};
			return `${opt.y}/${opt.M}/${opt.d}`
		},
		dubble(num) {
			if (num < 10) {
				return '0' + num
			} else {
				return num
			}
		},
		
		scrollTo() {
			let hash = window.location.hash;
			hash = hash.replace(/[\#|\s]/g, '');
			if (hash && document.getElementById(hash)) {
				// document.getElementById(hash).scrollIntoView({behavior:'auto'})
				const top = $(`#${hash}`).offset().top
				$('html, body').animate({scrollTop: top + 'px'})
			}
		},
		
		setSuccessNum() {
			this.$store.commit('setSuccessNum')
		},
		
		clearSuccessNum() {
			this.$store.commit('clearSuccessNum')
		},
		publink(name, item) {
			if (item.linkUrl) {
				window.open(item.linkUrl, '_blank')
				return
			}
			this.$router.push({ name, query: { uuid: item.uuid } })
		},
		bannerTurn(item) {
			if (!item.bannerUrl) return
			const url = item.bannerUrl.replace(/\s/g, '')
			if (!url) return
			window.open(item.bannerUrl, '_blank')
		},
		playSts(v = 0) {
			return '' // 暂时去掉
			return this.$t(`play${v}`)
		},
		menus() {
			return localStorage.getItem('menu')
		},
		showAd(v) {
			this.$store.commit('setOpenAd', v)
		},
		pageView(tip) {
			clearInterval(timer)
			let timeVal = 1
            let totalTime = 0
			this.$jsAPI('page', tip,
				{
					'page_duration': timeVal,
				}
			);
			timer = setInterval(() => {
				// if (timeVal === 1) {
				// 	timeVal = 30
				// } else {
				// 	timeVal += 30
				// }
				timeVal = 30
                totalTime += 30 * 1000
				this.$jsAPI('page', tip,
					{
						'page_duration': timeVal,
					}
				);
                if (totalTime > 2 * 60 * 60 * 1000) {
                    clearInterval(timer)
                }
			}, 30 * 1000)
		},
		getFirstLabel(dataTagTwoRes) {
			if (!dataTagTwoRes || !dataTagTwoRes.dataTagOne) return '无'
			const obj = this.labels.find(x => x.uuid === dataTagTwoRes.dataTagOne) || null
			if (obj) {
				return obj.lableDesc
			}
			return '无'
		},
		getSecLabel(dataTagTwoRes) {
			if (dataTagTwoRes && dataTagTwoRes.dataTagOne && dataTagTwoRes.dataTagOne === 'other') {
				return dataTagTwoRes.dataTagDesc || '无'
			}
			if (dataTagTwoRes && dataTagTwoRes.dataTagOne && dataTagTwoRes.dataTagOne !== 'other' && dataTagTwoRes.dataTagTwo) {
				const obj = this.labels.find(x => x.uuid === dataTagTwoRes.dataTagOne) || null
				if (obj && obj.lableCode) {
					return protal.getZdType(obj.lableCode).then((res) => {
						if (res && res.data && res.data.length) {
							return res.data.find(x => x.uuid === dataTagTwoRes.dataTagTwo) ? res.data.find(x => x.uuid === dataTagTwoRes.dataTagTwo).lableDesc : '无'
						}
					});
				}
			}
			return '无'
		}
  },
		
})



// WEBPACK FOOTER //
// ./src/mixin/index.js